import {
  report_to_excel_path
} from '~/routes';

export const Report = {

    list: function() {
        var table = jQuery('table.reports').dataTable({
            data: JSON.parse(jQuery('#report-data').html()),
            info: false,
            lengthChange: false,
            language: {
                searchPlaceholder: I18n.t('search')
              },
            autoWidth: false,
            initComplete: function () {
                DataTablesHelper.setAutoComplete(jQuery('table.reports'));
            },
            columnDefs: [
                {
                    render: function(data, type, row, meta) {
                        if (type == 'display') {
                            return jQuery('#report-name-template').html().
                                replace(/__id__/g, data.id).
                                replace(/__label__/g, data.label);
                        }
                        return data.label;
                    },
                    targets: [0]
                },
                {
                    orderable: false,
                    render: function(data, type, row, meta) {
                        if (type == 'display') {
                            return jQuery('#report-actions-template').html().
                                replace(/__id__/g, data.id).
                                replace(/__label__/g, data.label);
                        }
                        return '';
                    },
                    targets: [2]
                }
            ],
            footerCallback: function () {
                DataTablesHelper.togglePagination(this);
            }
        });

        table.on('click', 'a.delete-report', function() {
            var a = jQuery(this);

            if (confirm(a.attr('data-confirm'))) {
                jQuery.post(a.attr('href'), function() {
                    Turbo.visit(window.location.href);
                });
                a.hide();
            }
            return false;
        });
    },


    dashboard: function() {
        jQuery('.dashboard-widget[data-report-id]').each(function() {
            var container = jQuery(this);
            container.html(SmartME.loadingIndicator());
            container.load(container.attr('data-url'), function() {
                ActionJS.Report.show(container);
            });
        });
    },


    form_two_variable_relation: function() {
        jQuery('.modal-body .aggregate-select').on('change', function() {
            var varEnabled = jQuery(this).val() != 'count';
            jQuery('.modal-body .variable-y').css({opacity: varEnabled ? 1 : 0.5}).find('select').prop('disabled', !varEnabled);
        }).trigger('change');
    },


    show: function(container) {
        container = container || jQuery('body');

        var submitFilters = function() {
            if (container.is('.dashboard-widget')) {
                var form = jQuery(this).closest('form');
                container.html(SmartME.loadingIndicator());
                container.load(container.attr('data-url'), form.serialize(), function() {
                    ActionJS.Report.show(container);
                });
            } else {
                jQuery(this).closest('form').submit();
                container.html(SmartME.loadingIndicator());
            }
        };
        container.find('.report-filters select').on('change', submitFilters);
        container.find('.report-filters input[type="checkbox"]').on('click', submitFilters);

        // Call report type specific function
        (this['show_' + container.find('[data-report-type]').attr('data-report-type')] || (function(){}))(container);
    },

    // Deprecated?
    show_two_variable_relation: function(container) {
        container = container || jQuery('body');

        var table = container.find('table.report');
        var chart = container.find('.report-chart');

        if (table.length > 0) {
            table.dataTable({
                info: false,
                lengthChange: false,
                language: {
                    searchPlaceholder: I18n.t('search')
                  },
                autoWidth: false,
                paginate: false,
                data: JSON.parse(container.find('.report-table-data').html()),
                columnDefs: [
                    {
                        render: function(data, type, row, meta) {
                            if (type == 'display') {
                                return data.display;
                            } else if (table.attr('data-x-data-type') == 'string') {
                                // Sort string beginning with numbers by the numeric value.
                                return data.value ? String(data.value).match(/^\d+.*/) ? parseInt(data.value.split(/[^\d]/)[0], 10) : data.value : 0;
                            } else {
                                return data.value;
                            }
                        },
                        targets: [0]
                    },
                    {
                        render: function(data, type, row, meta) {
                            if (type == 'display') {
                                return data.display;
                            } else {
                                return data.value;
                            }
                        },
                        targets: [1, 2]
                    }
                ]
            });
        }

        if (chart.length > 0) {
            var ctx = chart.get(0).getContext('2d');
            var chartData = JSON.parse(container.find('.report-chart-data').html());

            // Create and save bar data here for reusability
            var bar_data = {
                labels: chartData.x,
                datasets: [{
                    label: chartData.y_title + (chartData.y_unit ? ' (' + chartData.y_unit + ')' : ''),
                    data: chartData.y,
                    borderColor: '#4BB6B1',
                    borderWidth: 1,
                    backgroundColor: 'rgba(75, 182, 177, 0.6)',
                }]
            }
            var bar_options = {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            callback: function(value, index, values) {
                                return StringHelper.addNumberDelimiter(Math.round(value * 10) / 10);
                            }
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            autoSkip: false,
                            callback: function(value, index, values) {
                                return value.length > 35 ? value.substr(0, 32) + '...' : value;
                            }
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function(tip, data) {
                            var total = 0.0;

                            data.datasets[0].data.forEach(function(d) {
                                if (d) {
                                    total += parseFloat(d);
                                }
                            });

                            var perc = (!total || !tip.yLabel || isNaN(total) ? '' : Math.round(tip.yLabel / total * 1000) / 10);
                            return ' ' + StringHelper.addNumberDelimiter(Math.round(tip.yLabel * 100) / 100) + ' (' + perc + ' %)';
                        }
                    }
                },
            }

            // If x is numeric, display a scatter line chart. Otherwise a bar chart.
            if (chartData.x_data_type == 'integer' || chartData.x_data_type == 'decimal') {
                new Chart(ctx, {
                    type: 'scatter',
                    data: {
                        datasets: [{
                            label: chartData.y_title + (chartData.y_unit ? ' (' + chartData.y_unit + ')' : ''),
                            borderColor: '#4BB6B1',
                            backgroundColor: 'rgba(75, 182, 177, 0.2)',
                            data: chartData.x.map(function(x, i) {
                                return {
                                    x: x,
                                    y: chartData.y[i] || 0
                                };
                            })
                        }]
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true,
                                    callback: function(value, index, values) {
                                        return StringHelper.addNumberDelimiter(Math.round(value * 10) / 10);
                                    }
                                }
                            }],
                            xAxes: [{
                                type: 'linear',
                                position: 'bottom',
                                ticks: {
                                    beginAtZero: true,
                                    callback: function(value, index, values) {
                                        return StringHelper.addNumberDelimiter(Math.round(value * 10) / 10);
                                    }
                                }
                            }]
                        },
                        tooltips: {
                            callbacks: {
                                label: function(tip, data) {
                                    return ' ' + StringHelper.addNumberDelimiter(tip.yLabel);
                                }
                            }
                        }
                    }
                });
            } else {
                new Chart(ctx, {
                    type: 'bar',
                    data: bar_data,
                    options: bar_options
                });
            }

            var createCanvas = function(context, width, height) {
                var bonus_offset = 0;
                Chart.defaults.global.defaultFontSize = 28;
                if (jQuery(context).attr('data-size') == 'print') {
                    Chart.defaults.global.defaultFontSize = 24;
                    bonus_offset = 10;
                }
                var c = document.createElement('canvas');
                c.width = width;
                c.height = height;

                new Chart(c, {
                    type: 'bar',
                    data: bar_data,
                    options: Object.assign({
                        responsive: false,
                        // Adding data labels
                        animation: {
                            duration: 1,                    
                            onComplete: function () {
                                var chartInstance = this.chart,
                                ctx = chartInstance.ctx;
                                ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                                ctx.textAlign = 'center';
                                ctx.textBaseline = 'bottom';

                                this.data.datasets.forEach(function (dataset, i) {
                                    var total = 0.0;

                                    dataset.data.forEach(function(d) {
                                        if(d) {
                                            total += parseFloat(d);
                                        }
                                    });

                                    var meta = chartInstance.controller.getDatasetMeta(i);

                                    meta.data.forEach(function (bar, index) {
                                        var data = dataset.data[index];
                                        data = Math.round(data*100)/100;
                                        var perc = (!total || isNaN(total) ? 0 : Math.round(parseFloat(data) / total * 1000) / 10);
                                        var label = data + ' (' + String(perc) + ' %)';
                                        var scale_max = bar._yScale.maxHeight;
                                        var offset = ((scale_max - bar._model.y) / scale_max >= 0.93) ? 20 + bonus_offset : -5;

                                        ctx.fillText(label, bar._model.x, bar._model.y + offset);
                                    });
                                });

                                c.getContext('2d').drawImage(c, 0,0,c.width, c.height, 0,0,width, height);
                                context.href = c.toDataURL();
                                Chart.defaults.global.defaultFontSize = 12;
                                jQuery(context)[0].click();
                            }
                        },
                        title: {
                            display: true,
                            text: jQuery('#report-title').text()
                        }
                    }, bar_options)
                });
            }

            jQuery('a.download').on('click', function() {
                if (this.href.match('#')) {
                    var isPrint = jQuery(this).attr('data-size') == 'print';
                    var width = isPrint ? 3508 : 1920;
                    // Height for print taken from niras a4 map size.
                    var height = isPrint ? 1973 : 1080;
                    createCanvas(this, width, height);
                    
                    this.download = "report.png";
                    return false;
                }
                else return true
            });
        }

        // Excel export
        jQuery('#excel').on('click', function(e) {
            var store = JSON.parse(jQuery('#store').text());
            var url = report_to_excel_path(Object.assign(store.filters, {report_id: store.rid}));
            this.target = '_blank';
            this.href = url;

            return true;
        });
    }
};


export const ReportVariable = {

    list: function() {
        // get the page length when first load
        var initWindowHeight = jQuery(window).height();
        var initItemsPerPage = getPageLength(initWindowHeight);

        var table = jQuery('table.report-variables').DataTable({
            data: JSON.parse(jQuery('#report-variable-data').html()),
            info: false,
            lengthChange: false,
            language: {
                searchPlaceholder: I18n.t('search')
              },
            pageLength: initItemsPerPage, 
            autoWidth: false,
            columnDefs: [
                {
                    render: function(data, type, row, meta) {
                        if (type == 'display') {
                            return jQuery('#report-variable-name-template').html().
                                replace(/__id__/g, data.id).
                                replace(/__label__/g, data.label);
                        }
                        return data.label;
                    },
                    targets: [0]
                },
                {
                    targets: [-1],
                    searchable: false,
                    sortable: false,
                },
            ]
        });

        table.on('click', 'a.delete-variable', function() {
            var a = jQuery(this);

            if (confirm(a.attr('data-confirm'))) {
                jQuery.post(a.attr('href'), function() {
                    Turbo.visit(window.location.href);
                });
                a.hide();
            }
            return false;
        });
        var resizeId;
        // get the length after user stop resizing for 500ms
        jQuery(window).resize(function(){
            clearTimeout(resizeId);
            resizeId = setTimeout(resizeList, 500);
        })
        function resizeList(){
            windowHeight = jQuery(window).height();
            itemsPerPage = getPageLength(windowHeight);
            if (itemsPerPage!=table.page.len()){
                table.page.len(parseInt(itemsPerPage)).draw();
            }
        }
        function getPageLength(height) {
            switch(true){
                case height>1100:
                    return 20;
                case height>800:
                    return 15;
                case height>600:
                    return 10;
                default:
                    return 5;
            }
        }
    },


    form: function() {
        jQuery('#variable_data_type').on('change', function() {
            var warning = jQuery('.modal-body .data-type-warning');

            if (warning.length > 0) {
                var select = jQuery(this);
                var origVal = select.attr('data-original-value');

                warning.html(warning.attr('data-text').replace('__to__', jQuery(this.options[this.selectedIndex]).text()));

                var isIncompatibleType = (select.val() != origVal && (select.val() == 'string' || origVal == 'string'));

                if (origVal != '' && select.val() != '' && isIncompatibleType) {
                    warning.show();
                } else {
                    warning.hide();
                }
            }
        });
    },


    edit_inputs: function() {
        ActionJS.ReportVariable.init_inputs();
        jQuery('.modal-body .nav-tabs').on('click', 'li a', function() {
            var currentLi = jQuery(this).closest('li');
            currentLi.closest('ul').find('li').removeClass('active');
            currentLi.addClass('active');
            jQuery('.modal-body .call-content').hide();
            jQuery('.modal-body .call-content.call-' + currentLi.attr('data-call-id')).show();
            return false;
        }).find('li.active a').trigger('click');

        jQuery('.modal-body .report-variable-input-mapping').on('change', 'tr.form select', function(){
          var index = jQuery(this).closest('.form').data('index');
          // Disable annex inputs or vice versa
          if (jQuery(this).val() !== "") {
            jQuery(this).closest('tbody').find("[data-index='" + index + "']").find("[data-type='programme_form']").not(this).prop('disabled', true);
            jQuery(this).closest('tbody').find("[data-index='" + index + "']").find("[data-type='project_call_phase_content']").not(this).prop('disabled', jQuery(this).data('type') == 'programme_form');
          } else {
            jQuery(this).closest('tbody').find("[data-index='" + index + "']").find('select').prop('disabled', false)
          }
        });


        if (jQuery('.modal-body .selection-options').length > 0) {
            // All possible options
            var selectionOptions = JSON.parse(jQuery('#selection-options-data').html());

            // Current set of options for the variable
            var checkedOptions = {};
            jQuery(JSON.parse(jQuery('#selected-selection-options-data').html())).each(function() {
                checkedOptions[this.value + '-' + this.label] = true;
            });

            var filterOptions = function() {
                jQuery('table.selection-options input.select-all').prop('checked', false);

                // Source inputs
                var sourceFieldIds = {};
                jQuery('.report-variable-input-mapping select').map(function() {
                    sourceFieldIds[jQuery(this).attr('data-form-id') + '-' + jQuery(this).val()] = true;
                });

                // Re-create the list from selected inputs
                var tableBody = jQuery('table.selection-options tbody');
                tableBody.html('');
                var optionTemplate = jQuery('#selection-option-template').html();
                var renderedOptions = {};
                jQuery.each(selectionOptions, function(fieldId, options) {
                    if (sourceFieldIds[fieldId]) {
                        jQuery.each(options, function() {
                            var optionId = this.value + '-' + this.label;

                            if (!renderedOptions[optionId]) {
                                tableBody.append(optionTemplate.
                                    replace(/__value__/g, this.value).
                                    replace(/__label__/g, this.label));
                                renderedOptions[optionId] = true;

                                var addedOption = tableBody.find('.option input').last();

                                addedOption.val(JSON.stringify(this));

                                if (checkedOptions[optionId]) {
                                    addedOption.prop('checked', true);
                                }
                            }
                        });
                    }
                });

                // Empty list warning
                var isEmptyList = (tableBody.find('tr.option').length == 0);
                jQuery('.alert.empty-selection-options').toggle(isEmptyList);
                jQuery('table.selection-options').toggle(!isEmptyList);
            };
            jQuery('.modal-body .report-variable-input-mapping').on('change', 'tr.form select', filterOptions);
            filterOptions();

            var updateCheckedOptions = function() {
                jQuery('.modal-body .selection-options .option input').each(function() {
                    checkedOptions[this.getAttribute('data-option-id')] = jQuery(this).is(':checked');
                });
            };
            jQuery('.modal-body .selection-options').on('click', '.option input', updateCheckedOptions);

            jQuery('.modal-body .selection-options').on('click', 'input.select-all', function() {
                jQuery('table.selection-options .option input').prop('checked', jQuery(this).is(':checked'));
                updateCheckedOptions();
            });
        }
    },

    init_inputs: function() {
        jQuery('tr.form select').each(function(elem) {
            var index = jQuery(this).closest('.form').data('index');
            if (jQuery(this).val() !== "") {
              jQuery(this).closest('tbody').find("[data-index='" + index + "']").find("[data-type='programme_form']").not(this).prop('disabled', true);
              jQuery(this).closest('tbody').find("[data-index='" + index + "']").find("[data-type='project_call_phase_content']").not(this).prop('disabled', jQuery(this).data('type') == 'programme_form');
            }
        });
    }
}